import { useState } from "react";
import { deleteEvalRun, getEvalRuns, postCreateEvalRun } from "./service";

import { EvalRunT } from "./types";

export default useEvalRuns;

function useEvalRuns(workspaceId, assistantId) {
  const [evalRuns, setEvalRuns] = useState<Array<Partial<EvalRunT>>>([]);
  const [pagination, setPagination] = useState({
    page: 1,
    total: 0,
    limit: 20,
    totalPages: 1,
  });
  const [isEvalRunsLoading, setIsEvalRunsLoading] = useState<boolean>(true);

  const fetchEvalRuns = async (params, loading = false) => {
    function init() {
      setIsEvalRunsLoading(loading);
    }

    function success(data) {
      setIsEvalRunsLoading(false);
      setEvalRuns(data.evalRuns);
      setPagination(data.pagination);
    }

    function error(e) {
      setIsEvalRunsLoading(false);
    }

    const { page = 1, limit = 20 } = params;
    const request = {
      params: { workspaceId, assistantId },
      queryParams: { page, limit },
    };

    init();
    try {
      const response = await getEvalRuns(request);
      success(response.data);
    } catch (e) {
      error(e);
    }
  };

  const createEvalRun = async (evalRun, lifecycleCbs) => {
    lifecycleCbs.init();

    try {
      const { name, ...config } = evalRun ?? {};

      const request = {
        params: { workspaceId, assistantId },
        body: { config, name },
      };
      const response = await postCreateEvalRun(request);
      lifecycleCbs.success();
      fetchEvalRuns({ page: 1, limit: 20 }, false);
    } catch (e) {
      lifecycleCbs.error(e);
    }
  };

  const runEvalTemplate = async (templateId, lifecycleCbs) => {
    lifecycleCbs.init();

    try {
      const request = {
        params: { workspaceId, assistantId },
        body: { templateId },
      };
      await postCreateEvalRun(request as any);
      lifecycleCbs.success();
      fetchEvalRuns({ page: 1, limit: 20 }, false);
    } catch (e) {
      lifecycleCbs.error(e);
    }
  };

  const removeEvalRun = async (evalRunId, lifecycleCbs) => {
    lifecycleCbs.init();

    try {
      const request = {
        params: { workspaceId, evalRunId },
      };

      const response = await deleteEvalRun(request);
      fetchEvalRuns({ page: 1, limit: 20 }, false);
      lifecycleCbs.success(response.data);
    } catch (e) {
      lifecycleCbs.error(e);
    }
  };

  return {
    evalRuns,
    pagination,
    isEvalRunsLoading,
    fetchEvalRuns,
    createEvalRun,
    runEvalTemplate,
    removeEvalRun,
  };
}
